import { defaultRangeExtractor, type Range } from '@tanstack/react-virtual'
import { mountAllRangeExtractor } from '@renderer/utils/virtualization-mount-all'
import { useSidepanelFindInPageOpen } from '../atoms'

/**
 * TanStack Virtual `rangeExtractor` that mounts every row while the sidepanel
 * find bar is open, so native find-in-page can match offscreen content.
 * Windowed rendering resumes as soon as the bar closes.
 */
export function useFindInPageRangeExtractor(): (range: Range) => Array<number> {
  const findInPageOpen = useSidepanelFindInPageOpen()
  return findInPageOpen ? mountAllRangeExtractor : defaultRangeExtractor
}
